var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paynext"},[_c('Step',{staticClass:"step",attrs:{"active":_vm.active_index,"thirdText":"购买成功"}}),_c('PayStatusBar',{attrs:{"status":Number(_vm.status),"type":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }